import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import { BADGE_DEFAULT } from './constants';
import css from './ProductBadge.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var getPercentOff = function getPercentOff(_ref) {
  var compareAtPrice = _ref.compareAtPrice,
      price = _ref.price;

  if (!price || price >= compareAtPrice) {
    return false;
  }

  var percentOff = Math.round((compareAtPrice - price) / compareAtPrice * 100);
  return "".concat(Math.floor(percentOff / 5) * 5, "% off");
};

var Badge = function Badge(_ref2) {
  var backgroundColor = _ref2.backgroundColor,
      badgeType = _ref2.badgeType,
      color = _ref2.color,
      compareAtPrice = _ref2.compareAtPrice,
      inline = _ref2.inline,
      price = _ref2.price,
      customText = _ref2.text;
  var discount = badgeType === 'DISCOUNT';
  var none = badgeType === 'NONE';
  var text = discount ? getPercentOff({
    compareAtPrice: compareAtPrice,
    price: price
  }) : customText;
  return !none && (text === null || text === void 0 ? void 0 : text.length) > 0 && /*#__PURE__*/_jsx("div", {
    className: cc([css.root, _defineProperty({}, css.inline, inline)]),
    style: {
      backgroundColor: backgroundColor
    },
    children: /*#__PURE__*/_jsx("span", {
      className: css.text,
      style: {
        color: color
      },
      children: text
    })
  });
};

Badge.defaultProps = _objectSpread(_objectSpread({}, BADGE_DEFAULT), {}, {
  inline: false
});
Badge.propTypes = {
  backgroundColor: PropTypes.string,
  badgeType: PropTypes.string,
  color: PropTypes.string,
  compareAtPrice: PropTypes.number,
  inline: PropTypes.bool,
  price: PropTypes.number,
  text: PropTypes.string
};
export default Badge;